function openMenu() {
	document.getElementById("overlay").style.display = "block";
}